import { PostboxDocument } from 'common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-10/common-utilities';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-10/frontend-integration';
import { PostboxDocumentsDataSelector } from './PostboxDocumentsSelector';
import { fetchPostboxDocuments } from './PostboxDocumentsSlice';

export function usePostboxDocuments(): AbstractDataState<PostboxDocument[], DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchPostboxDocuments, PostboxDocumentsDataSelector);
}
